import { render, staticRenderFns } from "./Skandia.vue?vue&type=template&id=2bb8326e&scoped=true&"
import script from "./Skandia.vue?vue&type=script&lang=js&"
export * from "./Skandia.vue?vue&type=script&lang=js&"
import style0 from "./Skandia.vue?vue&type=style&index=0&id=2bb8326e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb8326e",
  null
  
)

export default component.exports